export const messages = {
  'network_error': 'No se puede conectar al servidor. Verifica tu conexión a internet.',
  'user:invalid_user_pass': 'El usuario o la contraseña son incorrectos. Por favor, inténtalo nuevamente.',
  'user:no_payload_login': 'Datos de inicio de sesión faltantes.',
  'user:recovery_start': 'Se ha enviado un correo electrónico con las instrucciones para recuperar tu contraseña. Por favor, revisa tu bandeja de entrada.',
  'user:recovery_fail': 'Ocurrió un error al intentar enviar el correo de recuperación. Por favor, intenta nuevamente más tarde.',
  'user:reset_fail': 'Ocurrió un error al cambiar la contraseña.',
  'case:exists': 'El rut ingresado ya existe',
  'project:no_edit_archived': 'No se puede modificar un proyecto archivado.',
  'case:archived_project': 'No se puede modificar un caso de un proyecto archivado',
  'task:add_on_archived_project': 'No se puede agregar una tarea a un proyecto archivado',
  'task:edit_on_archived_project': 'No se puede editar una tarea de un proyecto archivado',
  'task:delete_on_archived_project': 'No se puede borrar una tarea de un proyecto archivado',
  'error': 'Error al guardar proyecto.'
}
